/* Product page behaviour — snippets/pdp-main.liquid, used by sections/main-product,
   pendant-product and necklace-product (see assets/ao-pdp.css).
   Plain JS, no Bootstrap: gallery (thumbnail rail, swipe position bar, zoom), tabs,
   native <dialog>s, the estimated delivery date, Style With recommendations, the pendant
   page's Pair with a Chain row and the add-to-cart form (which hands off to the cart drawer
   in sections/slide-rings-cart, pairing a chain with a pendant on the way). */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 992px)');

  // The cart drawer (sections/slide-rings-cart) defines Shopify.onaddSuccess, onError and
  // updateProductAddToCartState in a DOMContentLoaded handler. This deferred script runs before
  // DOMContentLoaded (readyState is already 'interactive' by then), so on a slow page the cart
  // check came back before they existed: wait for it. The drawer listens on window, so this
  // does too (a document listener runs first); added after the drawer's, it runs after it.
  var domReady = document.readyState === 'complete';
  var readyQueue = [];
  function onDomReady() {
    if (domReady) return;
    domReady = true;
    readyQueue.splice(0).forEach(function (fn) {
      fn();
    });
  }
  if (!domReady) {
    window.addEventListener('DOMContentLoaded', onDomReady);
    window.addEventListener('load', onDomReady); // added after DOMContentLoaded (theme editor)
  }
  function whenReady(fn) {
    if (domReady) fn();
    else readyQueue.push(fn);
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var scroller = root.querySelector('[data-ao-pdp-scroller]');
    if (!scroller) return;
    var slides = [].slice.call(scroller.querySelectorAll('[data-ao-pdp-media]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-ao-pdp-thumb]'));
    var bar = root.querySelector('[data-ao-pdp-progress]');
    var holdUntil = 0;

    // The header section stays pinned at the top: keep the rail (and jumps) below it. Measured
    // on load and resize only — these run on every scroll frame, which must not force style.
    var header = document.getElementById('shopify-section-header');
    var siteHeader = (header && header.querySelector('.site_header')) || header;
    var pinned = 0;
    function syncOffset() {
      pinned = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
      root.style.setProperty('--ao-pdp-sticky', pinned + 'px');
    }
    syncOffset();
    window.addEventListener('resize', syncOffset);
    // The bottom of what covers the top of the window: the pinned header — the visible part of
    // it, since up to 1080px it slides away on scroll down — and the add-to-cart bar (initBar)
    function coverBottom() {
      var nav = pinned ? Math.max(0, siteHeader.getBoundingClientRect().bottom) : 0;
      return nav + (root.__aoPdpBar || 0);
    }

    // Once less of the image box shows under the header than the rail needs, the sticky rail
    // would be pushed up under the header: fade it out instead
    var gallery = root.querySelector('.ao-pdp__gallery');
    var rail = root.querySelector('.ao-pdp__rail');
    var railList = rail && rail.querySelector('.ao-pdp__thumbs');
    var railFrame = 0;
    function syncRail() {
      railFrame = 0;
      if (!desktop.matches) return;
      rail.classList.toggle('is-tucked', gallery.getBoundingClientRect().bottom - coverBottom() < railList.offsetHeight);
    }
    if (railList) {
      syncRail();
      window.addEventListener(
        'scroll',
        function () {
          if (!railFrame) railFrame = requestAnimationFrame(syncRail);
        },
        { passive: true }
      );
      window.addEventListener('resize', syncRail);
    }

    var current = 0; // the first thumb starts current (Liquid)
    function setCurrent(i) {
      if (i === current) return;
      current = i;
      thumbs.forEach(function (t, n) {
        if (n === i) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    // Desktop rail: scroll the image box to that image — to the top of the part of the box in
    // view, which is under the header and bar once the page has scrolled down
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var slide = slides[i];
        if (!slide) return;
        setCurrent(i);
        holdUntil = Date.now() + 1000; // don't let the scroll's in-between images flash the rail
        setTimeout(syncCurrentSoon, 1050);
        var hidden = Math.max(0, coverBottom() - scroller.getBoundingClientRect().top);
        scroller.scrollTo({ top: Math.max(0, slide.offsetTop - hidden), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });

    // The current image is the one showing most within the visible part of the image box:
    // below the pinned header and add-to-cart bar, above the bottom of the window. (The box
    // grows with the text column when a tab opens, so its middle can sit far off screen —
    // hence not a middle-of-the-box line.) Re-checked on scroll, resize and box resize.
    var curFrame = 0;
    function syncCurrent() {
      curFrame = 0;
      if (!desktop.matches) return;
      if (boxScrolled) rememberAnchor();
      if (Date.now() < holdUntil) return;
      var box = scroller.getBoundingClientRect();
      var top = Math.max(box.top, coverBottom());
      var bottom = Math.min(box.bottom, window.innerHeight);
      var best = -1;
      var most = 0;
      slides.forEach(function (slide, i) {
        var r = slide.getBoundingClientRect();
        var seen = Math.min(r.bottom, bottom) - Math.max(r.top, top);
        if (seen > most) {
          most = seen;
          best = i;
        }
      });
      if (best > -1) setCurrent(best);
    }
    function syncCurrentSoon() {
      if (!curFrame) curFrame = requestAnimationFrame(syncCurrent);
    }

    // Resizing the window changes every image's height, which left the box's scroll position
    // pointing part-way into a different image: keep the one at the top of the box where it was.
    // anchor = [image, how far down it the box is scrolled, as a share of its height]. Taken
    // only after the box itself scrolls: re-taken after a resize, it would measure the new
    // heights against the old scroll position.
    var anchor = null;
    var boxScrolled = false;
    scroller.addEventListener('scroll', function () {
      boxScrolled = true;
    }, { passive: true });
    function rememberAnchor() {
      boxScrolled = false;
      var at = scroller.scrollTop;
      anchor = null;
      for (var i = slides.length - 1; i >= 0; i--) {
        if (slides[i].offsetTop <= at) {
          anchor = [i, (at - slides[i].offsetTop) / (slides[i].offsetHeight || 1)];
          break;
        }
      }
    }
    function keepAnchor() {
      if (!anchor || !desktop.matches) return;
      var slide = slides[anchor[0]];
      var top = Math.round(slide.offsetTop + anchor[1] * slide.offsetHeight);
      if (Math.abs(scroller.scrollTop - top) > 1) scroller.scrollTop = top;
    }
    if (slides.length > 1 && 'ResizeObserver' in window) new ResizeObserver(keepAnchor).observe(slides[0]);
    if (thumbs.length) {
      scroller.addEventListener('scroll', syncCurrentSoon, { passive: true });
      window.addEventListener('scroll', syncCurrentSoon, { passive: true });
      window.addEventListener('resize', syncCurrentSoon);
      if ('ResizeObserver' in window) new ResizeObserver(syncCurrentSoon).observe(scroller);
    }

    // Desktop: room under the last image so it can scroll up to the top of the box (the box
    // runs down to Style With, below the fold, so its last image would otherwise sit out of view)
    var last = slides[slides.length - 1];
    function syncEndSpace() {
      var space = desktop.matches && last ? scroller.clientHeight - last.offsetHeight : 0;
      scroller.style.paddingBottom = space > 0 ? space + 'px' : '';
    }
    syncEndSpace();
    if (last && 'ResizeObserver' in window) {
      var ro = new ResizeObserver(syncEndSpace);
      ro.observe(scroller, { box: 'border-box' }); // the box grows when a tab opens
      ro.observe(last); // lazy image arriving
    }
    if (desktop.addEventListener) desktop.addEventListener('change', syncEndSpace);

    // Once the page has loaded, fetch the rest of the gallery in the background, so scrolling
    // or swiping to them doesn't wait on a download (and a decode) mid-gesture
    function warmGallery() {
      slides.forEach(function (slide) {
        var im = slide.querySelector('img[loading="lazy"]');
        if (im) im.loading = 'eager';
      });
    }
    if (document.readyState === 'complete') setTimeout(warmGallery, 500);
    else window.addEventListener('load', function () { setTimeout(warmGallery, 500); });

    // Product videos play muted on a loop, with no tap to pause (2026-10-23). With reduced
    // motion they wait to be started instead, and a click (tap) starts or stops one.
    var videos = scroller.querySelectorAll('video');
    if (reduceMotion) {
      videos.forEach(function (v) {
        v.autoplay = false;
        v.pause();
      });
    }
    function toggleVideo(v) {
      if (v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else v.pause();
    }

    var gal = {
      lastMove: 0, // when the mobile row last moved, so zoom can tell a tap from a swipe
      // the image on screen (desktop: the rail's current one; mobile: initLoop replaces this)
      slide: function () {
        return slides[desktop.matches ? current : 0];
      },
      current: function () {
        return current;
      },
    };
    if (videos.length && reduceMotion) {
      scroller.addEventListener('click', function (e) {
        var v = e.target.closest('video');
        if (v && Date.now() - gal.lastMove > 300) toggleVideo(v);
      });
    }
    initLoop(scroller, root.querySelector('[data-ao-pdp-track]'), slides, bar, gal);
    initZoom(scroller, gal, toggleVideo);
    if (videos.length && !reduceMotion) startOnTap(scroller);

    // A video shows once it has started (ao-pdp.css: its poster stands in until then, so iOS's
    // play button on one it won't autoplay never shows). After initLoop: covers its copies too.
    if (videos.length) {
      scroller.addEventListener(
        'playing',
        function (e) {
          if (e.target.tagName === 'VIDEO') e.target.setAttribute('data-ao-played', '');
        },
        true
      );
      scroller.querySelectorAll('video').forEach(function (v) {
        if (!v.paused && v.readyState > 2) v.setAttribute('data-ao-played', '');
      });
    }

    // A tablet turned from the phone layout to desktop: open the column on the image the row
    // was showing (initLoop does the reverse)
    if (gal.media && desktop.addEventListener) {
      desktop.addEventListener('change', function () {
        if (!desktop.matches) return;
        var i = gal.media();
        if (!slides[i]) return;
        setCurrent(i);
        scroller.scrollTop = slides[i].offsetTop;
        rememberAnchor();
      });
    }
  }

  /* Low Power Mode on iPhones stops even a muted video autoplaying (it waits behind its poster,
     ao-pdp.css): the page's first tap or swipe counts as the shopper's go-ahead, so start them
     then. Once they're all playing it stops listening. */
  function startOnTap(scroller) {
    var events = ['touchend', 'click'];
    function videos() {
      return Array.prototype.slice.call(scroller.querySelectorAll('video')); // with initLoop's copies
    }
    function kick() {
      videos().forEach(function (v) {
        if (!v.paused) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }
    function done() {
      if (videos().some(function (v) { return v.paused; })) return;
      events.forEach(function (t) { document.removeEventListener(t, kick, true); });
    }
    events.forEach(function (t) { document.addEventListener(t, kick, true); });
    videos().forEach(function (v) { v.addEventListener('playing', done); });
  }

  /* ---------- Mobile: endless swipe ----------
     The row is moved with a transform, not native scrolling (snap scrolling plus re-centring
     the scroll position locked up on phones). A sideways drag follows the finger; on release
     the row moves one image (or springs back), and once it lands the slides' flex `order`
     rotates so the image on screen sits in the middle with another either side. Vertical
     drags stay page scrolls (touch-action: pan-y). Nothing moves in the DOM, so videos keep
     playing and screen readers keep the real order. On desktop the track isn't moved (CSS)
     and the slides stack as blocks, where `order` does nothing. */
  function initLoop(scroller, track, slides, bar, gal) {
    if (!track || slides.length < 2) return;
    var items = slides.slice();
    // One either side needs three; with two, repeat the pair (hidden on desktop, out of the a11y
    // tree and the tab order). Not `inert`: an inert copy can't be touched, so a swipe or tap that
    // starts on one does nothing and the row was stuck once a copy came round.
    if (items.length === 2) {
      slides.forEach(function (slide) {
        var copy = slide.cloneNode(true);
        copy.setAttribute('data-ao-pdp-clone', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('a, button, iframe, video, [tabindex]').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        track.appendChild(copy);
        items.push(copy);
      });
    }
    var desktopSlide = gal.slide;
    gal.slide = function () {
      return desktop.matches ? desktopSlide() : items[shown];
    };
    // "Image 2 of 5" for screen readers as the row moves
    var live = document.createElement('p');
    live.className = 'visually-hidden';
    live.setAttribute('aria-live', 'polite');
    scroller.parentNode.appendChild(live);
    var EASE = 'transform 0.35s cubic-bezier(0.22, 0.61, 0.36, 1)';
    var n = items.length;
    var mid = Math.floor(n / 2);
    var start = 0; // which item sits at visual position 0
    var shown = 0; // which item is on screen once the row has landed
    var x = 0; // the track's offset in px
    var drag = null;
    var landing = 0;

    function width() {
      return scroller.getBoundingClientRect().width;
    }
    function move(px, animate) {
      x = px;
      animate = animate && !reduceMotion;
      track.style.transition = animate ? EASE : 'none';
      track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
      paintBar(animate);
    }
    // The bar runs 0..count; past either end it wraps (its ::after / ::before draw the part
    // that comes back in on the other side). A glide heads for whichever copy of the target is
    // nearest: from the last image to the first that's `count`, not 0 — animating to 0 swept
    // the bar back across every image. Once landed it's set to the plain value, unanimated.
    var painted = 0;
    function paintBar(animate) {
      var w = width();
      if (!bar || !w) return;
      var p = -x / w;
      var k = Math.max(0, Math.min(n - 1, Math.floor(p)));
      var media = +items[(start + k) % n].getAttribute('data-ao-pdp-media');
      var pos = media + p - k;
      var count = slides.length;
      if (animate) {
        while (pos - painted > count / 2) pos -= count;
        while (painted - pos > count / 2) pos += count;
      }
      painted = pos;
      bar.style.transition = animate ? EASE : 'none';
      bar.style.setProperty('--ao-pdp-pos', pos.toFixed(3));
    }
    function arrange(first) {
      start = ((first % n) + n) % n;
      items.forEach(function (el, i) {
        el.style.order = (i - start + n) % n;
      });
    }
    // Item i into the middle of the row, still `offset` px from its resting place
    function centre(i, offset) {
      shown = i;
      arrange(i - mid);
      move(-mid * width() + (offset || 0), false);
    }
    // [the item nearest the screen, how far the row is from resting on it]
    function nearest() {
      var w = width();
      var at = Math.round(-x / w);
      return [(((start + at) % n) + n) % n, x + at * w];
    }
    var announced = 0;
    function land() {
      landing = 0;
      if (desktop.matches) return;
      centre(nearest()[0]);
      var media = +items[shown].getAttribute('data-ao-pdp-media');
      if (media !== announced) {
        announced = media;
        live.textContent = 'Image ' + (media + 1) + ' of ' + slides.length;
      }
      if (gal.landed) gal.landed();
    }
    // the image on screen and the one either side (initZoom sharpens those in the background)
    gal.near = function () {
      return [items[shown], items[(shown + 1) % n], items[(shown - 1 + n) % n]];
    };
    function go(pos) {
      gal.lastMove = Date.now();
      move(-Math.max(0, Math.min(n - 1, pos)) * width(), true);
      clearTimeout(landing);
      landing = setTimeout(land, reduceMotion ? 0 : 380);
    }
    // A row caught mid-move (catchRow) and then let go without a sideways swipe — a tap, or a
    // vertical page scroll — would otherwise stay parked between two images
    function settleIfOff() {
      var off = nearest()[1];
      if (Math.abs(off) > 0.5) go(Math.round(-x / width()));
      else if (off) centre(nearest()[0]); // a sliver of the next image would show along the edge
    }
    // A touch while the row is still moving stops it where it is, to carry on from there
    function catchRow() {
      if (!landing) return;
      clearTimeout(landing);
      landing = 0;
      var t = getComputedStyle(track).transform;
      if (t && t !== 'none' && window.DOMMatrixReadOnly) x = new DOMMatrixReadOnly(t).m41;
      var here = nearest();
      centre(here[0], here[1]);
    }

    // On the box, not the moving track: the track's own box is mostly off screen, so a touch on
    // the image showing reaches the track only through its children
    scroller.addEventListener('pointerdown', function (e) {
      if (desktop.matches || scroller.classList.contains('is-zooming')) return;
      // a second finger is a pinch (the page zooms, touch-action): put the row back where the
      // drag began rather than swiping with the first finger
      if (drag) {
        if (e.pointerId !== drag.id) {
          var d = drag;
          drag = null;
          go(Math.round(-d.base / width()));
        }
        return;
      }
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      catchRow();
      drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, base: x, axis: '', lastX: e.clientX, lastT: e.timeStamp, v: 0 };
    });
    scroller.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      // a mouse let go outside the box (no pointerup here): don't drag the row on hover
      if (e.pointerType === 'mouse' && !(e.buttons & 1)) return release(e);
      var dx = e.clientX - drag.x0;
      var dy = e.clientY - drag.y0;
      if (!drag.axis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (drag.axis === 'y') {
          drag = null; // the page scrolls
          return settleIfOff();
        }
        try {
          scroller.setPointerCapture(e.pointerId);
        } catch (err) {}
      }
      if (e.timeStamp > drag.lastT) drag.v = (e.clientX - drag.lastX) / (e.timeStamp - drag.lastT);
      drag.lastX = e.clientX;
      drag.lastT = e.timeStamp;
      gal.lastMove = Date.now();
      move(drag.base + dx, false);
      // However far the drag goes, keep an image queued on both sides (a 2- or 3-image row has
      // only one): a width from the middle, rotate the row under the finger and carry on
      var w = width();
      var p = -x / w;
      if (Math.abs(p - mid) >= 1) {
        var at = Math.round(p);
        var before = x;
        centre((((start + at) % n) + n) % n, x + at * w);
        drag.base += x - before;
      }
    });
    // Once a drag is sideways, cancel the touch's own scrolling, as Swiper does: otherwise
    // Chrome takes the swipe for a fling and spends the next tap stopping it, so that tap
    // never became a click (no zoom)
    scroller.addEventListener('touchmove', function (e) {
      if (drag && drag.axis === 'x' && e.cancelable) e.preventDefault();
    }, { passive: false });
    function release(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      if (d.axis !== 'x') return settleIfOff(); // a tap (zoom's click handler takes it) or a page scroll
      var w = width();
      var moved = x - d.base;
      var v = e.timeStamp - d.lastT > 100 ? 0 : d.v; // held still before letting go: no flick
      var step = 0;
      if (e.type === 'pointerup') {
        if (Math.abs(v) > 0.3) step = v < 0 ? 1 : -1;
        else if (Math.abs(moved) > w * 0.2) step = moved < 0 ? 1 : -1;
      }
      go(Math.round(-d.base / w) + step);
    }
    scroller.addEventListener('pointerup', release);
    scroller.addEventListener('pointercancel', release);

    // Arrow keys when the row has focus (a zoomed image zooms back out first)
    scroller.addEventListener('keydown', function (e) {
      if (desktop.matches || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      e.preventDefault();
      if (gal.zoomOut) gal.zoomOut();
      if (landing) {
        clearTimeout(landing);
        land();
      }
      go(mid + (e.key === 'ArrowRight' ? 1 : -1));
    });

    // Re-centre when the row changes width (rotation, switching from desktop); iOS also fires
    // resize as its toolbar slides away, which must not jump the row. Mid-glide, land on the
    // image it was gliding to; coming from desktop, on the image the rail had current.
    var lastWidth = 0;
    function reset() {
      if (desktop.matches) return void (lastWidth = 0);
      var w = width();
      if (w === lastWidth) return;
      var keep = shown;
      if (!lastWidth) keep = Math.max(0, gal.current());
      else if (landing) keep = (((start + Math.round(-x / lastWidth)) % n) + n) % n;
      lastWidth = w;
      clearTimeout(landing);
      landing = 0;
      centre(keep);
    }
    gal.media = function () {
      return +items[shown].getAttribute('data-ao-pdp-media');
    };
    reset();
    window.addEventListener('resize', reset);
    if (desktop.addEventListener) desktop.addEventListener('change', reset);
  }

  /* ---------- Zoom: click (tap) an image to zoom 2x where you clicked, drag to move around,
     click again — or click elsewhere / Escape — to zoom back out ---------- */
  function initZoom(scroller, gal, toggleVideo) {
    var SCALE = 2;
    var active = null;
    var tx = 0;
    var ty = 0;
    var drag = null;

    function img(slide) {
      return slide.querySelector('img');
    }
    // The photo as drawn in its box. On desktop it's fitted whole (object-fit: contain), so one
    // that isn't the box's shape is smaller than the box, with bands either side.
    function drawn(slide) {
      var w = slide.clientWidth;
      var h = slide.clientHeight;
      var im = img(slide);
      var ar = im.naturalWidth / im.naturalHeight;
      if (!desktop.matches || !ar || !isFinite(ar)) return { w: w, h: h };
      return { w: Math.min(w, h * ar), h: Math.min(h, w / ar) };
    }
    // Pan no further than the zoomed photo's edges (not into the bands)
    function clamp() {
      var d = drawn(active);
      var maxX = Math.max(0, (d.w * SCALE - active.clientWidth) / 2);
      var maxY = Math.max(0, (d.h * SCALE - active.clientHeight) / 2);
      tx = Math.max(-maxX, Math.min(maxX, tx));
      ty = Math.max(-maxY, Math.min(maxY, ty));
    }
    function paint() {
      img(active).style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + SCALE + ')';
    }
    // The page loads each photo at the size it's shown; zoomed it is twice that, so fetch the
    // srcset's file for that size off-page and only point the img at it once it's decoded.
    // Setting `sizes` straight away made Chrome drop the shown photo until the new file
    // arrived: a flash of empty box before the zoom.
    // Settles once the img shows that file (or it failed); `background` fetches at low priority.
    function sharpen(im, sizes, background) {
      if (!im.srcset || im.sizes === sizes) return Promise.resolve();
      if (im.getAttribute('data-zoom-sizes') === sizes) return im.__aoSharpen || Promise.resolve();
      im.setAttribute('data-zoom-sizes', sizes);
      var pre = new Image();
      if (background) pre.fetchPriority = 'low';
      pre.sizes = sizes;
      pre.srcset = im.srcset;
      function swap() {
        if (im.getAttribute('data-zoom-sizes') === sizes) im.sizes = sizes;
      }
      im.__aoSharpen = (pre.decode ? pre.decode() : Promise.reject()).then(swap, function () {
        if (pre.complete) return pre.naturalWidth ? swap() : undefined;
        return new Promise(function (done) {
          pre.onload = pre.onerror = function () {
            if (pre.naturalWidth) swap();
            done();
          };
        });
      });
      return im.__aoSharpen;
    }
    // Twice the photo's drawn width (the srcset is by width): on desktop that's the fitted photo's;
    // on phones the box's longer side, as before
    function zoomSize(slide) {
      var w = desktop.matches ? drawn(slide).w : Math.max(slide.clientWidth, slide.clientHeight);
      return Math.ceil(w * SCALE) + 'px';
    }
    function zoomIn(slide, x, y) {
      var r = slide.getBoundingClientRect();
      var im = img(slide);
      sharpen(im, zoomSize(slide));
      active = slide;
      // keep the clicked point under the pointer
      tx = (1 - SCALE) * (x - r.left - r.width / 2);
      ty = (1 - SCALE) * (y - r.top - r.height / 2);
      clamp();
      slide.classList.add('is-zoomed');
      scroller.classList.add('is-zooming');
      paint();
    }
    function zoomOut() {
      if (!active) return;
      img(active).style.transform = '';
      active.classList.remove('is-zoomed', 'is-panning');
      scroller.classList.remove('is-zooming');
      active = null;
    }
    gal.zoomOut = zoomOut;

    // Keyboard: Enter on the focused image box zooms the image on screen into its middle (and
    // back out), or plays/pauses a video
    scroller.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.target !== scroller) return;
      var slide = gal.slide();
      if (!slide) return;
      var v = slide.querySelector('video');
      if (v) return toggleVideo(v);
      if (!slide.hasAttribute('data-zoomable') || !img(slide)) return;
      e.preventDefault();
      if (slide === active) return zoomOut();
      zoomOut();
      var r = slide.getBoundingClientRect();
      zoomIn(slide, r.left + r.width / 2, r.top + r.height / 2);
    });

    // Zoom in/out on `click`, not pointerup: browsers only send click for a real tap, never for
    // a touch that stops or reverses a swipe, which used to zoom and so lock the row mid-swipe.
    // As a backstop, a click within 300ms of the row (or the desktop box) moving is not a tap.
    var lastType = 'mouse';
    var lastScroll = 0;
    var panned = false;
    scroller.addEventListener('scroll', function () { lastScroll = Date.now(); }, { passive: true });

    scroller.addEventListener('click', function (e) {
      var slide = e.target.closest('.ao-pdp__slide[data-zoomable]');
      if (!slide || !img(slide)) return;
      if (panned) return void (panned = false); // the end of a drag, not a click
      if (Date.now() - gal.lastMove < 300) return; // the end of a swipe
      if (lastType !== 'mouse' && Date.now() - lastScroll < 300) return;
      if (slide === active) zoomOut();
      else {
        zoomOut();
        zoomIn(slide, e.clientX, e.clientY);
      }
    });

    // Dragging a zoomed image moves it around
    scroller.addEventListener('pointerdown', function (e) {
      lastType = e.pointerType || 'mouse';
      panned = false;
      if (!active || e.button > 0 || !active.contains(e.target)) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, tx: tx, ty: ty, moved: false };
      active.setPointerCapture(e.pointerId);
      e.preventDefault(); // no text selection while panning
    });
    scroller.addEventListener('pointermove', function (e) {
      if (!drag || !active || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      var dy = e.clientY - drag.y;
      if (!drag.moved && Math.abs(dx) + Math.abs(dy) > 5) drag.moved = panned = true;
      if (!drag.moved) return;
      active.classList.add('is-panning');
      tx = drag.tx + dx;
      ty = drag.ty + dy;
      clamp();
      paint();
    });
    function endDrag() {
      drag = null;
      if (active) active.classList.remove('is-panning');
    }
    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('dragstart', function (e) {
      if (e.target.closest('[data-zoomable]')) e.preventDefault();
    });
    document.addEventListener('pointerdown', function (e) {
      if (active && !active.contains(e.target)) zoomOut();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') zoomOut();
    });
    window.addEventListener('resize', zoomOut);

    // Zoomed, a photo needs a bigger file than the page loads, and a click used to start that
    // download: the photo visibly sharpened after zooming. So once the page and its photos have
    // loaded, sharpen them in the background, one at a time — on desktop every photo (the one in
    // view first, a hovered one next), on phones the one on screen and its neighbours, following
    // the row. Not with Data Saver on or on a slow connection.
    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g|3g/.test(conn.effectiveType || ''))) return;
    var queue = [];
    var warming = false;
    var ready = false;
    function warm(list) {
      list = list.filter(function (slide) {
        return slide && slide.hasAttribute('data-zoomable') && img(slide);
      });
      queue = list.concat(
        queue.filter(function (slide) {
          return list.indexOf(slide) < 0;
        })
      );
      pump();
    }
    function pump() {
      if (!ready || warming || !queue.length) return;
      var slide = queue.shift();
      warming = true;
      sharpen(img(slide), zoomSize(slide), true).then(function () {
        warming = false;
        pump();
      });
    }
    function nearby() {
      if (!desktop.matches) return gal.near ? gal.near() : [gal.slide()];
      var all = [].slice.call(scroller.querySelectorAll('[data-ao-pdp-media]:not([data-ao-pdp-clone])'));
      var first = Math.max(0, all.indexOf(gal.slide()));
      return all.slice(first).concat(all.slice(0, first));
    }
    gal.landed = function () {
      if (ready && !desktop.matches) warm(nearby());
    };
    scroller.addEventListener('pointerover', function (e) {
      var slide = e.pointerType === 'mouse' && ready && e.target.closest('.ao-pdp__slide[data-zoomable]');
      if (slide && desktop.matches) warm([slide]);
    });
    // After the gallery's own photos (warmGallery lets the lazy ones load 500ms after load)
    function start() {
      var waited = 0;
      (function check() {
        var loading = [].some.call(scroller.querySelectorAll('img'), function (im) {
          return !im.complete;
        });
        if (loading && waited < 10000) {
          waited += 500;
          setTimeout(check, 500);
          return;
        }
        ready = true;
        warm(nearby());
      })();
    }
    if (document.readyState === 'complete') setTimeout(start, 1000);
    else window.addEventListener('load', function () { setTimeout(start, 1000); });
  }

  /* ---------- Tabs: opening one closes the one that was open (the user, 2026-10-26) ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-ao-acc]').forEach(function (group) {
      function setOpen(item, open) {
        item.classList.toggle('is-open', open);
        item.querySelector('[data-ao-acc-toggle]').setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ao-acc-toggle]');
        if (!btn || !group.contains(btn)) return;
        var item = btn.closest('.ao-acc__item');
        var open = !item.classList.contains('is-open');
        if (open) {
          group.querySelectorAll(':scope > .ao-acc__item.is-open').forEach(function (other) {
            setOpen(other, false);
          });
        }
        setOpen(item, open);
      });
    });
  }

  /* ---------- Dialogs (Drop a Hint, Authentication Standards) ----------
     Submitting the hint is handled by the #drop-a-hint-form handler in scripts.js,
     which closes the <dialog> it sits in through window.aoPdpCloseDialog.
     Opening and closing animate like the old Bootstrap modal: .is-open drives the
     transitions in ao-pdp.css, and closeDialog waits them out before dialog.close(). */

  // Longest delay + duration among the dialog's and its backdrop's transitions, in ms
  function dialogTransitionMs(dialog) {
    var longest = 0;
    [getComputedStyle(dialog), getComputedStyle(dialog, '::backdrop')].forEach(function (cs) {
      var durations = (cs.transitionDuration || '0s').split(',');
      var delays = (cs.transitionDelay || '0s').split(',');
      durations.forEach(function (d, i) {
        longest = Math.max(longest, (parseFloat(d) + parseFloat(delays[i % delays.length])) * 1000);
      });
    });
    return longest;
  }

  // iOS Safari rings any button that script focuses, even after a tap: the close button
  // showModal focuses, and the opener focus goes back to. ao-pdp.css shows those rings only
  // under body.is-tabbing (the class style.css and facets.js already use): Tab turns it on,
  // any pointer press turns it off.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') document.body.classList.add('is-tabbing');
  }, true);
  document.addEventListener('pointerdown', function () {
    document.body.classList.remove('is-tabbing');
  }, true);

  function openDialog(dialog) {
    dialog.showModal();
    void dialog.offsetWidth; // flush the closed styles so .is-open transitions from them
    dialog.classList.add('is-open');
  }

  function closeDialog(dialog) {
    if (!dialog.open || dialog.classList.contains('is-closing')) return;
    dialog.classList.remove('is-open');
    dialog.classList.add('is-closing');
    setTimeout(function () {
      // A native close (e.g. a second Escape) may already have run and cleared is-closing
      if (dialog.classList.contains('is-closing')) dialog.close();
    }, dialogTransitionMs(dialog));
  }
  window.aoPdpCloseDialog = closeDialog;

  function initDialogs(root) {
    var opener = null;
    root.addEventListener('click', function (e) {
      var open = e.target.closest('[data-ao-dialog-open]');
      if (open) {
        var dialog = document.getElementById(open.getAttribute('data-ao-dialog-open'));
        if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
        opener = open;
        openDialog(dialog);
        document.documentElement.classList.add('ao-dialog-lock');
        return;
      }
      var close = e.target.closest('[data-ao-dialog-close]');
      if (close) {
        var parent = close.closest('dialog');
        if (parent) closeDialog(parent);
      }
    });
    root.querySelectorAll('dialog.ao-dialog').forEach(function (dialog) {
      // A click on the dialog element itself (not its box) is a click on the backdrop — if it
      // started there too: selecting text in a field and letting go past the box also sends
      // the dialog a click
      var downOnBackdrop = false;
      dialog.addEventListener('pointerdown', function (e) {
        downOnBackdrop = e.target === dialog;
      });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog && downOnBackdrop) closeDialog(dialog);
        downOnBackdrop = false;
      });
      // Escape: play the exit animation instead of the instant native close
      dialog.addEventListener('cancel', function (e) {
        e.preventDefault();
        closeDialog(dialog);
      });
      dialog.addEventListener('close', function () {
        dialog.classList.remove('is-open', 'is-closing');
        document.documentElement.classList.remove('ao-dialog-lock');
        if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
        opener = null;
      });
    });
  }

  /* ---------- Drop a Hint form (snippets/pdp-dialogs) ----------
     Sent from here, so the page works without jQuery; the jQuery handlers in scripts.js are
     left for the old Bootstrap modal (snippets/product-modals) and skip this form. The browser
     checks the required fields before submit fires. */
  function initHint(root) {
    var form = root.querySelector('#drop-a-hint-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = {};
      new FormData(form).forEach(function (value, key) {
        data[key.trim()] = String(value).trim();
      });
      if (!data.your_email || !data.recipient_email) return;
      fetch('https://digitality.ba/klaviyo.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }).catch(function (err) {
        console.error('Drop a hint error:', err);
      });
      form.reset();
      var dialog = form.closest('dialog');
      if (dialog) closeDialog(dialog);
    });
    // Enter moves to the next field instead of sending; the note keeps its newlines
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.isComposing || e.target.tagName !== 'INPUT') return;
      e.preventDefault();
      var fields = [].slice.call(form.querySelectorAll('input:not([type="hidden"]), textarea')).filter(function (el) {
        return el.getClientRects().length > 0;
      });
      var next = fields[fields.indexOf(e.target) + 1];
      if (next) next.focus();
    });
  }

  /* ---------- "Estimated Delivery: Monday October 12th" ---------- */
  /* US federal holidays (no USPS delivery) on the day they're observed: a Saturday one moves to
     the Friday, a Sunday one to the Monday. Keyed 'year-month-day', month from 0. */
  var holidayYears = {};
  function dayKey(d) {
    return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate();
  }
  function holidays(y) {
    if (holidayYears[y]) return holidayYears[y];
    function fixed(m, day) {
      var d = new Date(y, m, day);
      if (d.getDay() === 6) d.setDate(day - 1);
      else if (d.getDay() === 0) d.setDate(day + 1);
      return d;
    }
    // the nth weekday (0 = Sunday) of a month; n = -1 for the last one
    function nth(m, weekday, n) {
      var d = n > 0 ? new Date(y, m, 1) : new Date(y, m + 1, 0);
      var shift = n > 0 ? ((weekday - d.getDay() + 7) % 7) + (n - 1) * 7 : -((d.getDay() - weekday + 7) % 7);
      return new Date(y, m, d.getDate() + shift);
    }
    var keys = {};
    [
      fixed(0, 1), // New Year's Day
      fixed(12, 1), // next New Year's Day, observed on December 31st when it's a Saturday
      nth(0, 1, 3), // Martin Luther King Jr. Day
      nth(1, 1, 3), // Presidents' Day
      nth(4, 1, -1), // Memorial Day
      fixed(5, 19), // Juneteenth
      fixed(6, 4), // Independence Day
      nth(8, 1, 1), // Labor Day
      nth(9, 1, 2), // Columbus Day
      fixed(10, 11), // Veterans Day
      nth(10, 4, 4), // Thanksgiving
      fixed(11, 25) // Christmas
    ].forEach(function (d) {
      keys[dayKey(d)] = true;
    });
    return (holidayYears[y] = keys);
  }

  function initDelivery(root) {
    root.querySelectorAll('[data-ao-pdp-delivery]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-ao-pdp-delivery'), 10);
      if (!(days > 0)) return;
      var d = new Date();
      d.setHours(12, 0, 0, 0);
      for (var added = 0; added < days; ) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6 && !holidays(d.getFullYear())[dayKey(d)]) added++;
      }
      var day = d.getDate();
      var suffix = day % 100 >= 11 && day % 100 <= 13 ? 'th' : { 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th';
      el.textContent =
        'Estimated Delivery: ' +
        d.toLocaleDateString('en-US', { weekday: 'long' }) +
        ' ' +
        d.toLocaleDateString('en-US', { month: 'long' }) +
        ' ' +
        day +
        suffix;
      el.hidden = false;
    });
  }

  /* ---------- Style With: related recommendations, topped up from the Liquid fallback ---------- */
  function initStyleWith(root) {
    var box = root.querySelector('[data-ao-sw]');
    if (!box) return;
    var grid = box.querySelector('[data-ao-sw-grid]');

    // Load the row's images once the page has loaded, before anyone scrolls down to them
    var loaded = document.readyState === 'complete';
    function warm() {
      grid.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    }
    if (loaded) setTimeout(warm, 500);
    else window.addEventListener('load', function () {
      loaded = true;
      setTimeout(warm, 500);
    });

    // data-no-recs: the row shows only its own collection (the necklace page's pendants, the
    // pendant page's chains)
    if (!window.fetch || box.hasAttribute('data-no-recs')) return;
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 3;
    var handle = box.getAttribute('data-handle');
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url =
      base +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(box.getAttribute('data-product-id')) +
      '&limit=' +
      Math.min(10, limit + 2) + // the endpoint allows up to 10
      '&intent=related';

    function sized(src) {
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    }

    function item(p) {
      var li = document.createElement('li');
      li.className = 'ao-sw__item';
      li.setAttribute('data-handle', p.handle);
      var a = document.createElement('a');
      a.className = 'ao-sw__link';
      a.href = p.url || base + 'products/' + p.handle;
      var img = document.createElement('img');
      img.src = sized(p.featured_image);
      img.alt = p.title || '';
      img.width = 400;
      img.height = 400;
      img.loading = loaded ? 'eager' : 'lazy'; // before load, wait for it (warm() then loads them)
      img.decoding = 'async';
      a.appendChild(img);
      li.appendChild(a);
      return li;
    }

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        var seen = {};
        seen[handle] = true;
        var picks = [];
        ((data && data.products) || []).forEach(function (p) {
          if (picks.length >= limit || !p || !p.handle || seen[p.handle]) return;
          if (p.available === false || !p.featured_image) return;
          seen[p.handle] = true;
          picks.push(item(p));
        });
        if (!picks.length) return;
        [].slice.call(grid.children).forEach(function (li) {
          var h = li.getAttribute('data-handle');
          if (picks.length >= limit || seen[h]) return;
          seen[h] = true;
          picks.push(li);
        });
        grid.replaceChildren.apply(grid, picks);
        if (loaded) warm();
      })
      .catch(function () {});
  }

  /* ---------- Pair with a Chain (pendant page, snippets/pdp-pair-chain) ----------
     A chain opens the shared chain lightbox (snippets/chain-lightbox, in the cart drawer
     section), which adds it to the cart. "View All Pairings" opens a side panel of chains. Not a
     <dialog>: the lightbox opens over the panel, and a modal dialog's top layer would sit above
     it and make it inert. So focus is kept in the panel here, and Escape is left to the
     lightbox while that's open. */
  function initPairChain(root) {
    function lightboxOpen() {
      var lb = document.getElementById('chainLightbox');
      return !!lb && lb.classList.contains('active');
    }

    root.addEventListener('click', function (e) {
      var chain = e.target.closest('[data-ao-chain]');
      if (!chain || !root.contains(chain)) return;
      if (typeof window.openChainLightbox === 'function') window.openChainLightbox(chain, e);
      else if (chain.getAttribute('data-chain-url')) window.location.href = chain.getAttribute('data-chain-url');
    });

    var wrap = root.querySelector('[data-ao-chains]');
    if (!wrap) return;
    var panel = wrap.querySelector('[data-ao-chains-panel]');
    var list = wrap.querySelector('[data-ao-chains-list]');
    var opener = null;

    // A fresh order each visit, with no "Abbott & Oaks - New" chain in the first four places
    // while there are others to swap in (as the old style-with-chain slideout did)
    if (list) {
      var items = [].slice.call(list.children);
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = items[i];
        items[i] = items[j];
        items[j] = t;
      }
      var isNew = function (li) {
        return li.getAttribute('data-vendor') === 'Abbott & Oaks - New';
      };
      for (var a = 0; a < Math.min(4, items.length); a++) {
        if (!isNew(items[a])) continue;
        for (var b = 4; b < items.length; b++) {
          if (!isNew(items[b])) {
            t = items[a];
            items[a] = items[b];
            items[b] = t;
            break;
          }
        }
      }
      items.forEach(function (li) {
        list.appendChild(li);
      });
    }

    function open(from) {
      if (wrap.classList.contains('is-open')) return;
      opener = from;
      wrap.classList.add('is-open');
      document.documentElement.classList.add('ao-dialog-lock');
      panel.focus({ preventScroll: true });
    }
    function close() {
      if (!wrap.classList.contains('is-open')) return;
      wrap.classList.remove('is-open');
      document.documentElement.classList.remove('ao-dialog-lock');
      if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
      opener = null;
    }

    root.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-ao-chains-open]');
      if (openBtn) return open(openBtn);
      if (e.target.closest('[data-ao-chains-close]')) return close();
      // "+" adds the chain (sections/slide-rings-cart's .add_to_bag handler) and the cart drawer
      // opens; the panel steps aside for it
      if (e.target.closest('.ao-chains .add_to_bag')) close();
    });

    // Fires before the lightbox's own (document) Escape handler, so a lightbox still open here
    // is the one Escape closes
    panel.addEventListener('keydown', function (e) {
      if (lightboxOpen()) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        return close();
      }
      if (e.key !== 'Tab') return;
      var stops = [].slice.call(panel.querySelectorAll('button, a[href]')).filter(function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
      if (!stops.length) return;
      var first = stops[0];
      var last = stops[stops.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ---------- Add to cart ---------- */

  // A chain picked for a pendant in the cart drawer ("Pair with a chain" under the pendant)
  // arrives on its product page with sessionStorage.pendantPairing = { id, variant, title,
  // chain } (sections/slide-rings-cart). Adding that chain here links it to the pendant, as long
  // as the pendant is still in the cart. Resolves with the add's response either way.
  function pairWithPendant(added) {
    var pairing = null;
    try {
      pairing = JSON.parse(sessionStorage.getItem('pendantPairing') || 'null');
    } catch (err) {}
    var variantId = added && (added.variant_id || added.id);
    if (!pairing || !variantId || String(variantId) !== String(pairing.chain)) return Promise.resolve(added);

    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var pendantInCart = cart.items.some(function (i) {
          return String(i.variant_id) === String(pairing.variant) || (pairing.id && String(i.product_id) === String(pairing.id));
        });
        if (!pendantInCart) {
          sessionStorage.removeItem('pendantPairing');
          return added;
        }
        var line = cart.items.filter(function (i) {
          return String(i.variant_id) === String(variantId);
        })[0];
        if (!line) return added;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: line.key,
            quantity: line.quantity,
            properties: Object.assign({}, line.properties, {
              _linked_pendant_variant: pairing.variant,
              _linked_pendant_product: pairing.id,
              'Paired with': pairing.title || 'Your pendant',
            }),
          }),
        }).then(function (res) {
          if (!res.ok) throw new Error('Pair failed');
          sessionStorage.removeItem('pendantPairing');
          return added;
        });
      })
      .catch(function (err) {
        // the chain is in the cart regardless; it just isn't linked
        console.error('Pendant pairing error:', err);
        return added;
      });
  }

  function initCartForm(root) {
    var form = root.querySelector('#AddToCartForm');
    var btn = root.querySelector('#AddToCart');
    if (!form || !btn) return;
    var status = root.querySelector('[data-ao-pdp-status]');

    // Sold out stays disabled whatever happens (gift cards aren't tracked)
    function soldOut() {
      return btn.getAttribute('data-inventory-tracked') !== 'false' && !(parseInt(btn.getAttribute('data-inventory'), 10) > 0);
    }
    // Loading doesn't disable the button, so keyboard focus stays on it; a second press while
    // it's loading does nothing (the theme's .loading rule already ignores clicks)
    function setLoading(on) {
      btn.classList.toggle('loading', on);
      if (!on) btn.disabled = soldOut();
    }
    // A failure shows under the button; "Added to cart" is for screen readers only
    function say(text, quiet) {
      if (!status) return;
      status.classList.toggle('visually-hidden', !!quiet);
      status.textContent = text;
    }

    // Sold out / already in your cart / Add to cart, from the live cart
    function checkStock() {
      return fetch('/cart.js?timestamp=' + Date.now())
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          whenReady(function () {
            if (window.Shopify && typeof Shopify.updateProductAddToCartState === 'function') {
              Shopify.updateProductAddToCartState(cart);
            } else {
              setLoading(false);
            }
          });
        })
        .catch(function () {
          setLoading(false);
        });
    }

    // A picked GIA report (snippets/pdp-options) is its own product, sent in the same request
    // as a line nested under the piece: Shopify keeps it under the piece and removes it with
    // the piece, and if the piece can't be added neither is the report
    function addRequest() {
      var gia = form.querySelector('[data-ao-gia-variant]:checked');
      if (!gia) {
        return {
          type: 'application/x-www-form-urlencoded; charset=UTF-8',
          body: new URLSearchParams(new FormData(form)).toString(),
        };
      }
      var piece = { quantity: 1, properties: {} };
      new FormData(form).forEach(function (value, key) {
        var prop = /^properties\[(.+)\]$/.exec(key);
        if (prop) piece.properties[prop[1]] = value;
        else if (key === 'id' || key === 'quantity') piece[key] = Number(value);
      });
      var report = {
        id: Number(gia.getAttribute('data-ao-gia-variant')),
        quantity: 1,
        parent_id: piece.id,
        properties: { For: gia.getAttribute('data-ao-gia-for') },
      };
      return { type: 'application/json', body: JSON.stringify({ items: [piece, report] }) };
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled || btn.classList.contains('loading')) return;
      setLoading(true);
      say('');
      var request = addRequest();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': request.type },
        body: request.body,
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var data = null;
            try {
              data = text ? JSON.parse(text) : null;
            } catch (err) {}
            if (!res.ok) {
              var fail = new Error((data && (data.description || data.message)) || 'Error adding to cart');
              fail.data = data || { message: 'Error adding to cart', status: res.status };
              throw fail;
            }
            // with a report the answer is both lines; the rest wants the piece's
            return data && data.items ? data.items[0] : data;
          });
        })
        .then(pairWithPendant)
        .then(
          function (data) {
            whenReady(function () {
              say('Added to cart', true);
              // the cart drawer opens itself and resets this button's state
              if (window.Shopify && typeof Shopify.onaddSuccess === 'function') Shopify.onaddSuccess(data);
              else checkStock();
            });
          },
          function (err) {
            console.error('Add to cart error:', err);
            whenReady(function () {
              // onError greys the button out for "All available stock is in your cart" (and
              // re-enables it otherwise): leave that as it set it rather than re-enabling it here
              if (err.data && window.Shopify && typeof Shopify.onError === 'function') Shopify.onError(err.data);
              btn.classList.remove('loading');
              if (soldOut()) btn.disabled = true;
              if (!btn.disabled) {
                say((err.data && err.data.description) || 'Sorry, this piece couldn’t be added to your cart. Please try again.');
              }
            });
          }
        );
    });

    if (btn.getAttribute('data-variant-id')) checkStock();
    else setLoading(false);

    // Gift card amounts: the swatch (snippets/swatch) sets #productSelect and the button's
    // variant id, then fires change — show that variant's price and re-check its stock
    var select = form.querySelector('#productSelect');
    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        var price = opt.getAttribute('data-price');
        if (price) {
          [root.querySelector('#ProductPrice'), root.querySelector('[data-ao-pdp-bar-price]')].forEach(function (el) {
            if (el) el.textContent = price;
          });
        }
        btn.setAttribute('data-inventory', opt.getAttribute('data-inventory') || '0');
        say('');
        checkStock();
      });
    }
  }

  /* --u, one Figma px on desktop (the section's width / 1440, between 0.85 and 1), and how far
     down the page the section starts (the header above it), for the fold rule that sets the
     desktop gallery's minimum height — see ao-pdp.css */
  function initFold(root) {
    function sync() {
      root.style.setProperty('--u', Math.min(1, Math.max(0.85, root.clientWidth / 1440)) + 'px');
      root.style.setProperty('--ao-pdp-top', Math.round(root.getBoundingClientRect().top + window.pageYOffset) + 'px');
    }
    sync();
    window.addEventListener('resize', sync);
  }

  /* ---------- Floating add-to-cart bar ----------
     Shown once the main add-to-cart row has scrolled up under the header, and on phones while
     the ring size list is open over it. Its button submits
     #AddToCartForm (form attribute) and mirrors #AddToCart: label, disabled, loading. */
  function initBar(root) {
    var bar = root.querySelector('[data-ao-pdp-bar]');
    var btn = bar && bar.querySelector('[data-ao-pdp-bar-atc]');
    var buy = root.querySelector('.ao-pdp__buy');
    var main = root.querySelector('#AddToCart');
    if (!btn || !buy || !main) return;
    var header = document.getElementById('shopify-section-header');
    var siteHeader = header && header.querySelector('.site_header');

    function mirror() {
      var label = main.querySelector('#AddToCartText') || main;
      btn.textContent = label.textContent.trim();
      btn.disabled = main.disabled;
      var loading = main.classList.contains('loading');
      btn.classList.toggle('is-loading', loading);
      btn.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
    mirror();
    new MutationObserver(mirror).observe(main, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      childList: true,
      characterData: true,
      subtree: true,
    });

    // Where the pinned header ends: the bottom of its section. Below 1080px the header inside
    // slides away on scroll down, but the section stays put, so this edge doesn't move with it —
    // measured against the sliding header, the bar flipped in and out every frame while the
    // header slid past the buy row (the jitter on phones). On desktop the bar rides up with the
    // header in CSS instead (--ao-pdp-hdr-h, see ao-pdp.css). -1 when the header has left the
    // screen altogether, which happens when a popup locks scrolling with overflow:hidden on
    // <html> and un-pins it.
    // Measured on load and resize only: sync() runs on every scroll frame and must not force style
    var isSticky = false;
    var pinnedHeight = 0;
    var barHeight = 0;
    var rail = root.querySelector('.ao-pdp__thumbs');
    function measure() {
      isSticky = !!header && getComputedStyle(header).position === 'sticky';
      pinnedHeight = isSticky ? header.offsetHeight : 0;
      barHeight = bar.offsetHeight;
      if (siteHeader) {
        var h = siteHeader.getBoundingClientRect().height + 'px';
        bar.style.setProperty('--ao-pdp-hdr-h', h);
        if (rail) rail.style.setProperty('--ao-pdp-hdr-h', h); // it rides up with the header too
      }
    }
    measure();
    function headerBottom() {
      if (!isSticky) return 0;
      var bottom = header.getBoundingClientRect().bottom;
      return bottom <= 0 ? -1 : bottom;
    }

    // The ring size list (ao-pdp-options.js) lies over Add to Cart while it's open, so on phones
    // the bar shows then too (desktop keeps it as it was: the list just covers the button).
    // A press on the bar is a click outside the list, which closes it: the bar
    // stays until that click has landed, or it would go inert under the pointer and the click
    // would fall through to the page.
    var ringOpen = false;
    var held = false;
    var holdTimer = 0;
    bar.addEventListener('pointerdown', function () {
      held = true;
      clearTimeout(holdTimer);
    });
    function release() {
      if (!held) return;
      clearTimeout(holdTimer);
      holdTimer = setTimeout(function () {
        held = false;
        sync();
      }, 500);
    }
    window.addEventListener('pointerup', release, true);
    window.addEventListener('pointercancel', release, true);

    var shown = false;
    var frame = 0;
    var lastTop = -2;
    var lastCover = -1;
    var lastPad = '';
    // Reads first, then writes, and only what changed: writing the same values every frame
    // made the browser restyle the section on each scroll frame (the jitter on desktop)
    function sync() {
      frame = 0;
      var top = headerBottom();
      // Once the header has slid away (up to 1080px) the main button shows right up to the top
      // of the window, so the bar waits for it to leave that. Keyed on the header's class, which
      // flips once, not its moving edge (the flicker described above).
      var line = top > 0 && siteHeader && siteHeader.classList.contains('header--hidden') ? 0 : top;
      var want =
        top >= 0 && ((ringOpen && !desktop.matches) || held || buy.getBoundingClientRect().bottom < line);
      if (top >= 0 && Math.abs(top - lastTop) > 0.25) {
        lastTop = top;
        bar.style.setProperty('--ao-pdp-bar-top', top + 'px');
      }
      if (want !== shown) {
        shown = want;
        bar.classList.toggle('is-shown', shown);
        bar.inert = !shown;
        document.documentElement.classList.toggle('ao-pdp-bar-on', shown);
      }
      // the thumbnail rail tucks under it on desktop (--ao-pdp-bar on the rail, see ao-pdp.css)
      var cover = shown && desktop.matches ? barHeight : 0;
      if (cover !== lastCover) {
        lastCover = cover;
        root.__aoPdpBar = cover;
        if (rail) rail.style.setProperty('--ao-pdp-bar', cover + 'px');
      }
      // Something focused by keyboard is scrolled clear of the header and the bar (desktop: under
      // the nav; mobile: along the bottom), not left hidden behind them
      var padTop = pinnedHeight + cover;
      var padBottom = shown && !desktop.matches ? barHeight : 0;
      if (padTop + '/' + padBottom !== lastPad) {
        lastPad = padTop + '/' + padBottom;
        document.documentElement.style.scrollPaddingTop = padTop ? padTop + 'px' : '';
        document.documentElement.style.scrollPaddingBottom = padBottom ? padBottom + 'px' : '';
      }
    }
    sync();
    window.addEventListener('scroll', function () {
      if (!frame) frame = requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('resize', function () {
      measure();
      sync();
    });
    // popups and drawers lock scrolling through classes/styles on <html>/<body>, without a scroll event
    var lockWatch = new MutationObserver(function () {
      if (!frame) frame = requestAnimationFrame(sync);
    });
    [document.documentElement, document.body].forEach(function (el) {
      lockWatch.observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
    });

    // A size list opened low in the window would run down behind the bar: scroll the row and
    // its list clear of it (and of the header)
    function keepClear(ring) {
      var pop = ring.querySelector('[data-ao-ring-pop]');
      if (!pop) return;
      var top = Math.max(headerBottom(), 0) + 8;
      var bottom = window.innerHeight - barHeight - 8;
      var a = ring.getBoundingClientRect().top;
      var b = pop.getBoundingClientRect().bottom;
      var by = a < top ? a - top : b > bottom ? Math.min(b - bottom, a - top) : 0;
      if (by) window.scrollBy({ top: by, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    root.addEventListener('ao:ring-toggle', function (e) {
      ringOpen = e.detail.open;
      sync();
      if (ringOpen && shown && !desktop.matches) keepClear(e.target);
    });
  }

  function init(root) {
    if (!root || root.__aoPdp) return;
    root.__aoPdp = true;
    initFold(root);
    initBar(root);
    initGallery(root);
    initTabs(root);
    initDialogs(root);
    initHint(root);
    initDelivery(root);
    initStyleWith(root);
    initPairChain(root);
    initCartForm(root);
  }

  document.querySelectorAll('[data-ao-pdp]').forEach(init);
  // Theme editor re-renders
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-ao-pdp]'));
  });
})();
